import * as types from "../actionTypes/transferActionTypes";

const initial = {
  TransferSearchDetails: {
    data: {},
    apiState: "initial",
  },
  TransferListDetails: {
    data: {},
    apiState: "initial",
  },
  SelectedTransfers: {
    departure: null,
    return: null,
  },
  TransferPrebookDetails: {},
  TransferCheckoutDetails: {},
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const TransferReducer = (state = initial, action: any) => {
  switch (action.type) {
    // ------------------> GET_TRANSFER_SEARCH start
    case types.GET_TRANSFER_SEARCH.STARTED:
      return {
        ...state,
        TransferSearchDetails: { data: {}, apiState: "started" },
      };
    case types.GET_TRANSFER_SEARCH.FULLFILLED:
      return {
        ...state,
        TransferSearchDetails: { data: action.payload, apiState: "fulfilled" },
      };
    case types.GET_TRANSFER_SEARCH.REJECTED:
      return {
        ...state,
        TransferSearchDetails: { data: {}, apiState: "rejected" },
      };
    case types.RESET_GET_TRANSFER_SEARCH:
      return {
        ...state,
        TransferSearchDetails: { data: {}, apiState: "initial" },
      };
    // ------------------> GET_TRANSFER_SEARCH end

    // ------------------> GET_TRANSFER_LIST start
    case types.GET_TRANSFER_LIST.STARTED:
      return {
        ...state,
        TransferListDetails: { data: {}, apiState: "started" },
      };
    case types.GET_TRANSFER_LIST.FULLFILLED:
      return {
        ...state,
        TransferListDetails: { data: action.payload, apiState: "fulfilled" },
      };
    case types.GET_TRANSFER_LIST.REJECTED:
      return {
        ...state,
        TransferListDetails: { data: {}, apiState: "rejected" },
      };
    case types.RESET_GET_TRANSFER_LIST:
      return {
        ...state,
        TransferListDetails: { data: {}, apiState: "initial" },
      };
    // ------------------> GET_TRANSFER_LIST end

    case types.GET_TRANSFER_PREBOOK.FULLFILLED:
      return { ...state, TransferPrebookDetails: action.payload };
    case types.GET_TRANSFER_PREBOOK.REJECTED:
      return { ...state, TransferPrebookDetails: {} };

    case types.GET_TRANSFER_CHECKOUT.FULLFILLED:
      return { ...state, TransferCheckoutDetails: action.payload };
    case types.GET_TRANSFER_CHECKOUT.REJECTED:
      return {
        ...state,
        TransferCheckoutDetails: { data: {}, apiState: "rejected" },
      };

    case types.SET_SELECTED_TRANSFER:
      return {
        ...state,
        SelectedTransfers: action.payload,
      };
    case types.RESET_SELECTED_TRANSFER:
      return {
        ...state,
        SelectedTransfers: {},
      };

    default:
      return state;
  }
};

export default TransferReducer;
